package com.devsusana.portfolio.components.widgets

import androidx.compose.runtime.Composable
import com.devsusana.portfolio.styles.SitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

/**
 * Renders social icons and direct links for contact and profile exploration.
 */
@Composable
fun SocialLinks(modifier: Modifier = Modifier) {
    val colorMode = ColorMode.current

    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(1.cssRem),
        verticalAlignment = Alignment.CenterVertically
    ) {
        SocialLinkItem(
            label = "GitHub",
            url = "https://github.com/DEVSusana",
            colorMode = colorMode
        )
        SocialLinkItem(
            label = "LinkedIn",
            url = "https://www.linkedin.com/in/susanacordobaserrano/",
            colorMode = colorMode
        )
        SocialLinkItem(
            label = "Email",
            url = "mailto:susanacordobaserrano@gmail.com",
            colorMode = colorMode
        )
    }
}

@Composable
private fun SocialLinkItem(label: String, url: String, colorMode: ColorMode) {
    Link(
        path = url,
        variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
        modifier = Modifier
            .padding(leftRight = 0.75.cssRem, topBottom = 0.4.cssRem)
            .borderRadius(8.px)
            .border(1.px, org.jetbrains.compose.web.css.LineStyle.Solid, SitePalette.surfaceBorder(colorMode))
            .backgroundColor(SitePalette.surface(colorMode))
    ) {
        SpanText(
            text = label,
            modifier = Modifier
                .color(SitePalette.primaryAction(colorMode))
                .fontWeight(FontWeight.Medium)
                .fontSize(0.9.cssRem)
        )
    }
}
